import { useEffect, useState } from 'react';
import { FieldValues, Path, useFormContext } from 'react-hook-form';

export const useRangeInput = <TRelevantFields extends FieldValues>(
    initialFrom: number | undefined,
    initialTo: number | undefined,
    fromKey: Path<TRelevantFields>,
    toKey: Path<TRelevantFields>
) => {
    const { register, trigger, watch, setValue, getFieldState } = useFormContext<TRelevantFields>();

    const [showRange, setShowRange] = useState(
        !!initialFrom && !!initialTo && initialFrom !== initialTo
    );

    const [fromValue, toValue] = watch([fromKey, toKey]);
    const fromIsDirty = getFieldState(fromKey).isDirty;
    const toIsDirty = getFieldState(toKey).isDirty;

    // triggers validation as these fields are validated together
    // but defined on only one
    useEffect(() => {
        if (fromIsDirty && toIsDirty) {
            void trigger(fromKey);
        }
    }, [fromIsDirty, fromKey, toIsDirty, toValue, trigger]);

    useEffect(() => {
        if (showRange) {
            return;
        }

        setValue(toKey, fromValue, {
            shouldValidate: false,
            shouldDirty: false,
            shouldTouch: false,
        });
    }, [fromValue, setValue, showRange, toKey]);

    const onRangeClick = () => {
        if (showRange) {
            setShowRange(false);
            setValue(toKey, fromValue, { shouldValidate: true });
        } else {
            setShowRange(true);
            setValue(toKey, undefined as any, { shouldValidate: false });
        }
    };

    return {
        register,
        showRange,
        onRangeClick,
    };
};
